module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Sissach-2abdc3a8a2bebab91613ae961b2375c1.png";